import React from 'react';
import AppShell from '../components/AppShell';
import InboxTab from '../components/dash/InboxTab';
import { useMe, useFlash } from '../lib/useMe';

export default function InboxPage() {
  const [me] = useMe();
  const flash = useFlash();
  if (!me) return <AppShell title="Inbox"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell
      title="Inbox"
      subtitle="Your connection requests, accepted connections and private conversations."
      testid="inbox-page"
    >
      <InboxTab me={me} flash={flash} />
    </AppShell>
  );
}
